import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getAttributeOrThrow, getAttributeOrUndefined, qsRequired } from '@/scripts/core/global'

export class CartShippingBar extends UcoastEl {
	static htmlSelector = 'cart-shipping-bar'
	meter: HTMLElement
	message: HTMLElement
	isGWP: boolean
	gwpVariantId?: number
	threshold: number
	success: string
	pending: string
	renderedMessage: string
	percent: number

	constructor() {
		super()
		const { meter, message, isGWP, gwpVariantId } = this.loadEls(this)
		const { percent, success, pending, renderedMessage, threshold } = this.loadParams(this)
		this.meter = meter
		this.message = message
		this.isGWP = isGWP
		this.gwpVariantId = gwpVariantId
		this.threshold = threshold
		this.success = success
		this.pending = pending
		this.renderedMessage = renderedMessage
		this.percent = percent
		//this.updateMeter(this);
	}

	loadEls(el: HTMLElement) {
		const meter = qsRequired('[data-percent]', el)
		const message = qsRequired('[data-pending-message]', el)
		const gwpVariantId = getAttributeOrUndefined('data-gwp-variant-id', el)
		const isGWP = gwpVariantId ? true : false
		return {
			meter,
			message,
			isGWP,
			gwpVariantId: gwpVariantId ? parseInt(gwpVariantId) : undefined,
		}
	}

	loadParams(el: HTMLElement) {
		const { meter, message } = this.loadEls(el)
		const percent = parseInt(getAttributeOrThrow('data-percent', meter))
		const success = getAttributeOrThrow('data-success-message', message)
		const pending = getAttributeOrThrow('data-pending-message', message)
		const renderedMessage = getAttributeOrThrow('data-rendered-message', message)
		const threshold = parseInt(getAttributeOrThrow('data-threshold', meter))
		return {
			percent,
			success,
			pending,
			renderedMessage,
			threshold,
		}
	}

	updateMeter(el: HTMLElement) {
		console.log('updateMeter')
		const { percent, renderedMessage } = this.loadParams(el)
		if (this.meter.style.width === `${percent}%`) return
		this.meter.style.width = `${percent}%`
		this.message.innerHTML = renderedMessage
	}

	liveUpdateMeter(total: number) {
		const newPercent = total / this.threshold
		if (newPercent > 1) {
			this.meter.style.width = `100%`
			this.message.innerHTML = this.success
			return
		} else {
			this.meter.style.width = `${newPercent * 100}%`
			this.message.innerHTML = `$${((-1 * (total - this.threshold)) / 100).toFixed(2)}${this.pending}`
		}
	}
}
